import toast from "react-hot-toast";

/**
 * Generic API Error Handler
 * @param {object} error - Axios error
 * @param {function} setErrors - Formik setErrors (optional)
 * @param {string} fallbackMessage - Default error message
 */
const handleApiError = (error, setErrors, fallbackMessage = "Something went wrong") => {
  // Axios error with response
  if (error?.response?.data) {
    const { message, errors } = error.response.data;

    // ✅ Laravel / validation errors
    if (errors && typeof errors === "object") {
      // Set Formik field errors if available
      if (setErrors) {
        const formattedErrors = {};
        Object.keys(errors).forEach((key) => {
          formattedErrors[key] = errors[key][0];
        });
        setErrors(formattedErrors);
      }

      // Show first validation error in toast
      const firstError = Object.values(errors)[0]?.[0];
      if (firstError) {
        toast.error(firstError);
        return;
      }
    }

    // ✅ Normal backend message
    if (message) {
      toast.error(message);
      return;
    }
  }

  // ❌ Network / unknown error
  toast.error(fallbackMessage);
};

export default handleApiError;
